
  import {
    Component,
    Vue
  } from "vue-property-decorator";
  import CollapseItem from '@/components/collapse.vue';
  import PageFooter from '@/components/page-footer.vue';
  import {
    getOssToken
  } from '@/api/user'
  import {
    creareSupplier,
    setSupplier,
    supplierInfo
  } from '@/api/supplier'
  import UploadImg from '@/components/upload-img.vue';
  import AddressSelect from '@/components/address-select.vue';
  import {
    getUserId
  } from "@/utils/storage";
    import {
    getProviderReturnLogistics
  } from '@/api/logistics'
  import {imgHost} from '@/utils/config'

  @Component({
    name: 'supplier-detail',
    components: {
      CollapseItem,
      PageFooter,
      UploadImg,
      AddressSelect
    }
  })
  export default class SupplierDetail extends Vue {
    private imgUrl = imgHost;
    private type = 'edit';
    private id = 0;
    private chooseTab = 0;
    private paperType = 0;
    private token = {}; // 上传token
    private papers: any = [{
      label: '居民身份证',
      value: 1
    }]
    private personRole: any = [{
      label: '法人代表',
      value: 1
    }]
    private formData: any = {
      HeadUrl: '',// (string, optional): 供应商头像,
      Account: '',// (string, optional): 账号,
      WeixinId: '',// (string, optional): 微信号,
      ProviderName: '',// (string, optional): 供应商名称,
      Phone: '',// (string, optional): 手机号,
      Province: '',// (string, optional): 省,
      City: '',// (string, optional): 市,
      Area: '',// (string, optional): 区,
      Address: '',// (string, optional): 详细地址,
      DeliveryTime: '',// (int): 发货时效--多少天内发货,
      RealName: '',// (string, optional): 真实姓名,
      CardType: 1,// (int, optional) = ['身份证:1']: 证件类型,
      IdCardNo: '',// (string, optional): 身份证号码,
      CompanyName: '',// (string, optional): 公司名称,
      LicenseImgId: '',// (string, optional): 公司证件号,
      PersonalRole: 1,// (int, optional) = ['法人代表:1']: 个人角色,
      LicenseImgUrl: '',// (string, optional): 营业执照,
      CardIdFrontImgUrl: '',// (string, optional): 身份证正面,
      CardIdBackImgUrl: '',// (string, optional): 身份证反面,
      ProviderReturnAddressDtoList: [],// (Array[ProviderReturnAddressDto], optional): 退货地址
    }
    private formRule: any = {
      // 'Account': '账号不能为空',
      // 'password': '密码不能为空',
      // 'ProviderName': '供应商名称不能为空',
      // 'Phone': '供应商手机号不能为空',
      // 'Province': '地址填写不完整',
      // 'City': '地址填写不完整',
      // 'Area': '地址填写不完整',
      // 'Address': '地址填写不完整',
      // 'DeliveryTime': '发货时效不能为空',
      // 'RealName': '请填写真实姓名', // 真实姓名
      // 'IdCardNo': '请填写身份证', // 身份证
      // 'CompanyName': '请填写公司名称', // 公司名称
      // 'LicenseImgId': '请填写公司证件号', // 公司证件
      // 'LicenseImgUrl': '请上传营业执照', // 营业执照
      // 'CardIdFrontImgUrl': '请上传身份证正面', // 身份证正面
      // 'CardIdBackImgUrl': '请上传身份证背面', // 身份证反面
    }
    private pageNo = 1;
    private pageSize = 10;
    private list: any = [];
    private total = 0;
    private disabled = false

    private get userId() {
      return getUserId()
    }

    private mounted() {
      if (this.type === 'edit') {
        this.getSupplierInfo();
      }
      // this.getList();
    }

    // 返回上一页
    private toBack() {
      // this.$router.go(-1)
    }

    // 获取token
    private async getToken() {
      try {
        const res: any = await getOssToken({})
        this.token = {
          AccessKeySecret: res.access_key_secret,
          OSSAccessKeyId: res.access_key_id,
          SecurityToken: res.security_token
        }
      } catch (e) {
        console.log('getOssToken ===>', e)
      }
    }

    // 上传成功
    private uploadSuc(list: any, type ? : string) {
      this.formData[type] = list[0]
			this.formData[type+'List'] = list
    }

    // 获取省市信息
    private getAddress(list: string[]) {
      this.formData.Province = list[0];
      this.formData.City = list[1];
      this.formData.Area = list[2];
    }

    // 数据是否为空
    private isEmpty() {
      for (let key in this.formData) {
        if (this.type == 'edit' && key === 'password') continue;
        if (this.formRule[key] && !this.formData[key]) {
          this.$message({
            type: 'warning',
            message: this.formRule[key]
          })
          return true
        }
      }
      return false;
    }

    // 获取供应商信息
    private async getSupplierInfo() {
      try {
        const res: any = await supplierInfo({})
        this.formData = res.Result;
				this.formData.LicenseImgUrlList = [this.formData.LicenseImgUrl]
				this.formData.CardIdFrontImgUrlList = [this.formData.CardIdFrontImgUrl]
				this.formData.CardIdBackImgUrlList = [this.formData.CardIdBackImgUrl]
      } catch (err) {
        console.error('supplierInfo ===>', err)
      }
    }

    // 提交信息
    private submit() {
      if (this.isEmpty()) return false;

      this.doUpdate()
      
    }

    // 更新
    private async doUpdate() {
      try {
        await setSupplier({ProviderInfo:this.formData});
        this.$message({
          type: 'success',
          message: '更新成功'
        })
      } catch (err) {
        this.$message({
          type: 'error',
          message: '更新失败'
        })
        console.log('setSupplier ===>', err)
      }
    }

    private async getList() {
      let params: any = {
        page_no: this.pageNo,
        page_size: this.pageSize,
      }
      try {
        const res: any = await getProviderReturnLogistics(params);
        this.list = res.info || [];
        this.total = res.count;
      } catch (e) {
        console.log(e)
      }
    }
  }
